/*eslint-disable */
import React, { useEffect, useState } from "react";
import MenuLayouts from "../layouts/menu.layout";
import FooterLayouts from "../layouts/footer.layout";
import BtnFloatingLayout from "../layouts/btn_flotante.layout";
import BannerMundialComponent from "../components/multi_cotizacion/banner-mundial.component";
import VideoMundialComponent from "../components/multi_cotizacion/video-mundial.component";
import ComoParticiparComponent from "../components/multi_cotizacion/como-participar.component";
import TerminosMundialComponent from "../components/multi_cotizacion/terminos-mundial.component";
import MenuMundialComponent from "../components/multi_cotizacion/menu-mundial.component";
import BannerComponent from "../components/multi_cotizacion/banner.component";
import DescriptionComponent from "../components/multi_cotizacion/description.component";
import CotizacionVehiculosComponent from "../components/multi_cotizacion/cotizacion-vehiculos.component";
import VehiculosComponent from "../components/multi_cotizacion/vehiculos.component";
import {
  multicotizador,
  vehiclesSimulator,
} from "../components/conexion/vehicles.conexion";
import "../assets/css/mundial-page-bg.css";
import "../assets/css/cotizador-mundial-override.css";

const MultiCotizacionMundialPage: React.FC = () => {
  const [visibleHeight, setVisibleHeight] = useState(0);
  const [vehiculosData, setVehiculosData]: any = useState([]);
  const [vehiculosSelected, setVehiculosSelected]: any = useState(null);
  const [multicotizadorData, setMulticotizadorData]: any = useState([]);

  useEffect(() => {
    vehiclesSimulator().then(function (res: any) {
      let data: any = res?.data?.data;
      setVehiculosData(data);
      setVehiculosSelected(data[0]);
      /* setModelo(vehiculo !== undefined && vehiculo !== "" ? vehiculo : data[0].slug)
            setVersion(vehiculo !== undefined && vehiculo !== "" ? data?.find((item: any) => item.slug ===  vehiculo)?.versions[0]?.name : data[0]?.versions[0]?.name) */
    });
    multicotizador().then(function (res: any) {
      setMulticotizadorData(res?.data?.data);
    });
  }, []);

  return (
    <>
      <MenuLayouts
        className="home-page"
        active="somos"
        setVisibleHeight={setVisibleHeight}
        visibleHeight={visibleHeight}
      />
      <div
        className="home-page mundial-page-parallax-bg" /* style={{backgroundColor: "#F6F3F2", height: "100vh"}} */
      >
        <h1
          style={{ position: "absolute", opacity: "0", pointerEvents: "none" }}
        >
          Multicotización Hyundai Colombia - Compara y Encuentra tu Mejor Opción
        </h1>

        <div className="home-page-mascara"></div>
        <MenuMundialComponent visibleHeight={visibleHeight} />
        <BannerComponent multicotizadorData={multicotizadorData} />
        <VideoMundialComponent />
        <BannerMundialComponent multicotizadorData={multicotizadorData} />
        <ComoParticiparComponent />
        {/* <DescriptionComponent multicotizadorData={multicotizadorData} /> */}

        <div className="cotizacion-multiple-component sin-background" id="cotizacion">
          
          <div className="mundial-cotizador-header">
            <h2>Agenda tu test drive</h2>
            <p>Selecciona el Hyundai que deseas cotizar</p>
          </div>

          <VehiculosComponent
            vehiculosData={vehiculosData}
            setVehiculosSelected={setVehiculosSelected}
          />
          {vehiculosSelected !== null ? (
            <CotizacionVehiculosComponent vehiculo={vehiculosSelected} />
          ) : null}
        </div>
        <TerminosMundialComponent />
      </div>
      <BtnFloatingLayout reserva="https://reservas.hyundaicolombia.co/" />
      <FooterLayouts />
    </>
  );
};

export default MultiCotizacionMundialPage;
